import {keyBy, some, omit} from 'lodash';
import {
  NEW_TEST_SCORE,
  EDIT_TEST_SCORE,
  CANCEL_EDIT_TEST_SCORE,
  DELETE_TEST_SCORE,
  RECEIVE_TEST_SCORE,
  SCROLLED_TO_SCORE,
  RECEIVE_TEST_SCORES,
} from 'shared/portfolio/actions/test-scores';

export function testScoresReducer(state = {}, action) {
  switch (action.type) {
    case RECEIVE_TEST_SCORE:
      return {
        ...state,
        [action.testScore._id]: {
          ...action.testScore,
        },
      };
    case NEW_TEST_SCORE:
      if (some(state, 'new')) {
        return state;
      } else {
        return {
          ...state,
          [action.testScore._id]: {
            ...action.testScore,
          },
        };
      }
    case EDIT_TEST_SCORE:
      return {
        ...state,
        [action.testScore._id]: {
          ...action.testScore,
          editing: true,
        },
      };
    case SCROLLED_TO_SCORE:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          scrollTo: false,
        },
      };
    case CANCEL_EDIT_TEST_SCORE:
      if (action.testScore.new) {
        return omit(state, action.testScore._id);
      } else {
        return {
          ...state,
          [action.testScore._id]: {
            ...action.testScore,
            editing: false,
            scrollTo: true,
          },
        };
      }
    case DELETE_TEST_SCORE:
      return omit(state, action.id);
    case RECEIVE_TEST_SCORES:
      return {...state, ...keyBy(action.testScores, '_id')};
    default:
      return state;
  }
}
